export default __webpack_public_path__ + "static/media/kitchenwares_study.f0032fda.jpg";